<template>
  <div class="content-container">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="备注" prop="note">
          <el-input
            v-model="form.note"
            required
            maxlength="500"
            :rows="4"
            show-word-limit
            type="textarea"
            placeholder="请输入备注信息"
            @keydown.enter.native="handleTextareaKeydown"
          />
        </el-form-item>
        <el-form-item label="附件">
          <MyUpload
            ref="myUpload"
            v-model="form.fileList"
            :accept="['.png','.jpg','.jpeg','.gif', '.pdf', '.doc', '.docx', '.xls', '.xlsx']"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyUpload from '@/components/approveUpload/approve.vue'
export default {
  name: 'RejectA',
  components: { MyUpload },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        note: '',
        fileList: ''
      },
      rules: {
        note: [{ required: true, message: '请输入备注信息', trigger: 'blur' }]
      },
      fileList: [],
      allowSize: 50 * 1024,
      limit: 5,
      operateType: null // 操作类型
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 限制输入框换行操作
    handleTextareaKeydown() {
      const e = window.event || arguments[0]
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false
        return false
      }
    },
    openDialog(obj) {
      this.dialogVisible = true
    },
    handleClose(done) {
      console.log('handleClose')
      this.$refs.form.resetFields()
      this.$set(this.form, 'fileList', null)
      this.$refs.myUpload.clearFileList()
      this.dialogVisible = false
    },
    submit() {
      switch (this.title) {
        case '驳回到发起人':
          this.operateType = 4
          break
        case '驳回到指定节点':
          this.operateType = 5
          break
        case '驳回到上一节点':
          this.operateType = 6
          break
        case '同意':
          this.operateType = 7
          break
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('this.form', this.form)
          this.$emit('submitForm', this.operateType, this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/views/taskManage/css/dialog.scss";
</style>
